/// <reference types="./html_parser.d.mts" />
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import {
  Ok,
  Error,
  toList,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
  isEqual,
} from "../gleam.mjs";

const FILEPATH = "src/common/html_parser.gleam";

export class EmptyElement extends $CustomType {}

export class StartElement extends $CustomType {
  constructor(name, attributes, children) {
    super();
    this.name = name;
    this.attributes = attributes;
    this.children = children;
  }
}

export class EndElement extends $CustomType {
  constructor(name) {
    super();
    this.name = name;
  }
}

export class Content extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Attribute extends $CustomType {
  constructor(key, value) {
    super();
    this.key = key;
    this.value = value;
  }
}

class Start extends $CustomType {}

class End extends $CustomType {}

class None extends $CustomType {}

function trim_space_to_elem_begin(loop$in) {
  while (true) {
    let in$ = loop$in;
    if (in$.startsWith("\n")) {
      let remain = in$.slice(1);
      loop$in = remain;
    } else if (in$.startsWith("\t")) {
      let remain = in$.slice(1);
      loop$in = remain;
    } else if (in$.startsWith("<")) {
      let remain = in$.slice(1);
      return "<" + remain;
    } else {
      return in$;
    }
  }
}

function remove_quotes(in$) {
  let remove_first_quote = (str) => {
    if (str.startsWith("\"")) {
      let remain = str.slice(1);
      return remain;
    } else {
      return str;
    }
  };
  let _pipe = in$;
  let _pipe$1 = remove_first_quote(_pipe);
  let _pipe$2 = $string.reverse(_pipe$1);
  let _pipe$3 = remove_first_quote(_pipe$2);
  return $string.reverse(_pipe$3);
}

function do_get_attrs_inner(
  loop$in,
  loop$key,
  loop$val,
  loop$finding_value,
  loop$inside_quotes
) {
  while (true) {
    let in$ = loop$in;
    let key = loop$key;
    let val = loop$val;
    let finding_value = loop$finding_value;
    let inside_quotes = loop$inside_quotes;
    if (in$ === "") {
      if (val === "") {
        if (key === "") {
          return [toList([]), ""];
        } else {
          return [toList([]), key];
        }
      } else {
        return [toList([new Attribute(key, remove_quotes(val))]), ""];
      }
    } else if (in$.startsWith(">")) {
      if (!inside_quotes) {
        let remain = in$.slice(1);
        if (val === "") {
          if (key === "") {
            return [toList([]), remain];
          } else {
            return [toList([new Attribute(key, remove_quotes(val))]), remain];
          }
        } else {
          return [toList([new Attribute(key, remove_quotes(val))]), remain];
        }
      } else {
        let $ = $string.pop_grapheme(in$);
        if (!($ instanceof Ok)) {
          throw makeError(
            "let_assert",
            FILEPATH,
            "common/html_parser",
            141,
            "do_get_attrs_inner",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $,
              start: 3720,
              end: 3776,
              pattern_start: 3731,
              pattern_end: 3750
            }
          )
        }
        let head = $[0][0];
        let remain = $[0][1];
        if (finding_value) {
          loop$in = remain;
          loop$key = key;
          loop$val = val + head;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        } else {
          loop$in = remain;
          loop$key = key + head;
          loop$val = val;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        }
      }
    } else if (in$.startsWith("=")) {
      if (!inside_quotes) {
        let remain = in$.slice(1);
        loop$in = remain;
        loop$key = key;
        loop$val = "";
        loop$finding_value = true;
        loop$inside_quotes = false;
      } else {
        let $ = $string.pop_grapheme(in$);
        if (!($ instanceof Ok)) {
          throw makeError(
            "let_assert",
            FILEPATH,
            "common/html_parser",
            141,
            "do_get_attrs_inner",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $,
              start: 3720,
              end: 3776,
              pattern_start: 3731,
              pattern_end: 3750
            }
          )
        }
        let head = $[0][0];
        let remain = $[0][1];
        if (finding_value) {
          loop$in = remain;
          loop$key = key;
          loop$val = val + head;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        } else {
          loop$in = remain;
          loop$key = key + head;
          loop$val = val;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        }
      }
    } else if (in$.startsWith("\"")) {
      if (finding_value) {
        let remain = in$.slice(1);
        loop$in = remain;
        loop$key = key;
        loop$val = val;
        loop$finding_value = finding_value;
        loop$inside_quotes = !inside_quotes;
      } else {
        let $ = $string.pop_grapheme(in$);
        if (!($ instanceof Ok)) {
          throw makeError(
            "let_assert",
            FILEPATH,
            "common/html_parser",
            141,
            "do_get_attrs_inner",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $,
              start: 3720,
              end: 3776,
              pattern_start: 3731,
              pattern_end: 3750
            }
          )
        }
        let head = $[0][0];
        let remain = $[0][1];
        if (finding_value) {
          loop$in = remain;
          loop$key = key;
          loop$val = val + head;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        } else {
          loop$in = remain;
          loop$key = key + head;
          loop$val = val;
          loop$finding_value = finding_value;
          loop$inside_quotes = inside_quotes;
        }
      }
    } else if (in$.startsWith(" ")) {
      if (!inside_quotes && !finding_value) {
        let remain = in$.slice(1);
        loop$in = remain;
        loop$key = key;
        loop$val = val;
        loop$finding_value = finding_value;
        loop$inside_quotes = inside_quotes;
      } else {
        if (!inside_quotes) {
          let remain = in$.slice(1);
          let $ = do_get_attrs_inner(remain, "", "", false, false);
          let attrs = $[0];
          let remain_after_attr = $[1];
          return [
            listPrepend(new Attribute(key, remove_quotes(val)), attrs),
            remain_after_attr,
          ];
        } else {
          let $ = $string.pop_grapheme(in$);
          if (!($ instanceof Ok)) {
            throw makeError(
              "let_assert",
              FILEPATH,
              "common/html_parser",
              141,
              "do_get_attrs_inner",
              "Pattern match failed, no pattern matched the value.",
              {
                value: $,
                start: 3720,
                end: 3776,
                pattern_start: 3731,
                pattern_end: 3750
              }
            )
          }
          let head = $[0][0];
          let remain = $[0][1];
          if (finding_value) {
            loop$in = remain;
            loop$key = key;
            loop$val = val + head;
            loop$finding_value = finding_value;
            loop$inside_quotes = inside_quotes;
          } else {
            loop$in = remain;
            loop$key = key + head;
            loop$val = val;
            loop$finding_value = finding_value;
            loop$inside_quotes = inside_quotes;
          }
        }
      }
    } else if (in$.startsWith("\n")) {
      if (!inside_quotes && !finding_value) {
        let remain = in$.slice(1);
        loop$in = remain;
        loop$key = key;
        loop$val = val;
        loop$finding_value = finding_value;
        loop$inside_quotes = inside_quotes;
      } else {
        if (!inside_quotes) {
          let remain = in$.slice(1);
          let $ = do_get_attrs_inner(remain, "", "", false, false);
          let attrs = $[0];
          let remain_after_attr = $[1];
          return [
            listPrepend(new Attribute(key, remove_quotes(val)), attrs),
            remain_after_attr,
          ];
        } else {
          let $ = $string.pop_grapheme(in$);
          if (!($ instanceof Ok)) {
            throw makeError(
              "let_assert",
              FILEPATH,
              "common/html_parser",
              141,
              "do_get_attrs_inner",
              "Pattern match failed, no pattern matched the value.",
              {
                value: $,
                start: 3720,
                end: 3776,
                pattern_start: 3731,
                pattern_end: 3750
              }
            )
          }
          let head = $[0][0];
          let remain = $[0][1];
          if (finding_value) {
            loop$in = remain;
            loop$key = key;
            loop$val = val + head;
            loop$finding_value = finding_value;
            loop$inside_quotes = inside_quotes;
          } else {
            loop$in = remain;
            loop$key = key + head;
            loop$val = val;
            loop$finding_value = finding_value;
            loop$inside_quotes = inside_quotes;
          }
        }
      }
    } else if (in$.startsWith("\t")) {
      if (!inside_quotes && !finding_value) {
        let remain = in$.slice(1);
        loop$in = remain;
        loop$key = key;
        loop$val = val;
        loop$finding_value = finding_value;
        loop$inside_quotes = inside_quotes;
      } else {
        if (!inside_quotes) {
          let remain = in$.slice(1);
          let $ = do_get_attrs_inner(remain, "", "", false, false);
          let attrs = $[0];
          let remain_after_attr = $[1];
          return [
            listPrepend(new Attribute(key, remove_quotes(val)), attrs),
            remain_after_attr,
          ];
        } else {
          let $ = $string.pop_grapheme(in$);
          if (!($ instanceof Ok)) {
            throw makeError(
              "let_assert",
              FILEPATH,
              "common/html_parser",
              141,
              "do_get_attrs_inner",
              "Pattern match failed, no pattern matched the value.",
              {
                value: $,
                start: 3720,
                end: 3776,
                pattern_start: 3731,
                pattern_end: 3750
              }
            )
          }
          let head = $[0][0];
          let remain = $[0][1];
          if (finding_value) {
            loop$in = remain;
            loop$key = key;
            loop$val = val + head;
            loop$finding_value = finding_value;
            loop$inside_quotes = inside_quotes;
          } else {
            loop$in = remain;
            loop$key = key + head;
            loop$val = val;
            loop$finding_value = finding_value;
            loop$inside_quotes = inside_quotes;
          }
        }
      }
    } else {
      let $ = $string.pop_grapheme(in$);
      if (!($ instanceof Ok)) {
        throw makeError(
          "let_assert",
          FILEPATH,
          "common/html_parser",
          141,
          "do_get_attrs_inner",
          "Pattern match failed, no pattern matched the value.",
          {
            value: $,
            start: 3720,
            end: 3776,
            pattern_start: 3731,
            pattern_end: 3750
          }
        )
      }
      let head = $[0][0];
      let remain = $[0][1];
      if (finding_value) {
        loop$in = remain;
        loop$key = key;
        loop$val = val + head;
        loop$finding_value = finding_value;
        loop$inside_quotes = inside_quotes;
      } else {
        loop$in = remain;
        loop$key = key + head;
        loop$val = val;
        loop$finding_value = finding_value;
        loop$inside_quotes = inside_quotes;
      }
    }
  }
}

function do_get_attrs(in$, key, val, finding_value) {
  return do_get_attrs_inner(in$, key, val, finding_value, false);
}

export function get_attrs(in$) {
  let _pipe = in$;
  let _pipe$1 = trim_space_to_elem_begin(_pipe);
  return do_get_attrs(_pipe$1, "", "", false);
}

function do_get_first_element(loop$in, loop$out, loop$currently_parsing) {
  while (true) {
    let in$ = loop$in;
    let out = loop$out;
    let currently_parsing = loop$currently_parsing;
    if (in$.startsWith("</")) {
      let remain = in$.slice(2);
      if (out === "") {
        loop$in = remain;
        loop$out = out;
        loop$currently_parsing = new End();
      } else {
        return [new Content(out), "</" + remain];
      }
    } else if (in$.startsWith("<")) {
      let remain = in$.slice(1);
      if (out === "") {
        loop$in = remain;
        loop$out = out;
        loop$currently_parsing = new Start();
      } else {
        return [new Content(out), "<" + remain];
      }
    } else if (in$.startsWith(">")) {
      let remain = in$.slice(1);
      if (currently_parsing instanceof Start) {
        return [new StartElement(out, toList([]), toList([])), remain];
      } else if (currently_parsing instanceof End) {
        return [new EndElement(out), remain];
      } else {
        return [new Content(out), remain];
      }
    } else if (in$.startsWith(" ")) {
      if (isEqual(currently_parsing, new Start())) {
        let remain = in$.slice(1);
        let $ = get_attrs(remain);
        let attrs = $[0];
        let remain_after_attr = $[1];
        return [new StartElement(out, attrs, toList([])), remain_after_attr];
      } else {
        let $ = $string.pop_grapheme(in$);
        if (!($ instanceof Ok)) {
          throw makeError(
            "let_assert",
            FILEPATH,
            "common/html_parser",
            81,
            "do_get_first_element",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $,
              start: 2080,
              end: 2136,
              pattern_start: 2091,
              pattern_end: 2110
            }
          )
        }
        let head = $[0][0];
        let remain = $[0][1];
        loop$in = remain;
        loop$out = out + head;
        loop$currently_parsing = currently_parsing;
      }
    } else if (in$.startsWith("\n")) {
      if (isEqual(currently_parsing, new Start())) {
        let remain = in$.slice(1);
        let $ = get_attrs(remain);
        let attrs = $[0];
        let remain_after_attr = $[1];
        return [new StartElement(out, attrs, toList([])), remain_after_attr];
      } else {
        let $ = $string.pop_grapheme(in$);
        if (!($ instanceof Ok)) {
          throw makeError(
            "let_assert",
            FILEPATH,
            "common/html_parser",
            81,
            "do_get_first_element",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $,
              start: 2080,
              end: 2136,
              pattern_start: 2091,
              pattern_end: 2110
            }
          )
        }
        let head = $[0][0];
        let remain = $[0][1];
        loop$in = remain;
        loop$out = out + head;
        loop$currently_parsing = currently_parsing;
      }
    } else if (in$.startsWith("\t")) {
      if (isEqual(currently_parsing, new Start())) {
        let remain = in$.slice(1);
        let $ = get_attrs(remain);
        let attrs = $[0];
        let remain_after_attr = $[1];
        return [new StartElement(out, attrs, toList([])), remain_after_attr];
      } else {
        let $ = $string.pop_grapheme(in$);
        if (!($ instanceof Ok)) {
          throw makeError(
            "let_assert",
            FILEPATH,
            "common/html_parser",
            81,
            "do_get_first_element",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $,
              start: 2080,
              end: 2136,
              pattern_start: 2091,
              pattern_end: 2110
            }
          )
        }
        let head = $[0][0];
        let remain = $[0][1];
        loop$in = remain;
        loop$out = out + head;
        loop$currently_parsing = currently_parsing;
      }
    } else if (in$ === "") {
      return [new EmptyElement(), ""];
    } else {
      let $ = $string.pop_grapheme(in$);
      if (!($ instanceof Ok)) {
        throw makeError(
          "let_assert",
          FILEPATH,
          "common/html_parser",
          81,
          "do_get_first_element",
          "Pattern match failed, no pattern matched the value.",
          {
            value: $,
            start: 2080,
            end: 2136,
            pattern_start: 2091,
            pattern_end: 2110
          }
        )
      }
      let head = $[0][0];
      let remain = $[0][1];
      loop$in = remain;
      loop$out = out + head;
      loop$currently_parsing = currently_parsing;
    }
  }
}

export function get_first_element(in$) {
  let _pipe = in$;
  let _pipe$1 = trim_space_to_elem_begin(_pipe);
  return do_get_first_element(_pipe$1, "", new None());
}

export function as_list(in$) {
  if (in$ === "") {
    return toList([]);
  } else {
    let $ = get_first_element(in$);
    let first = $[0];
    let remain = $[1];
    return listPrepend(first, as_list(remain));
  }
}

function do_as_tree(loop$in, loop$current) {
  while (true) {
    let in$ = loop$in;
    let current = loop$current;
    if (current instanceof StartElement) {
      let cur_name = current.name;
      let cur_attrs = current.attributes;
      let cur_children = current.children;
      if (in$ === "") {
        return [
          new StartElement(
            cur_name,
            cur_attrs,
            (() => {
              let _pipe = cur_children;
              return $list.reverse(_pipe);
            })(),
          ),
          "",
        ];
      } else {
        let $ = get_first_element(in$);
        let next = $[0];
        let remain = $[1];
        if (next instanceof EmptyElement) {
          if (remain === "") {
            return [
              new StartElement(
                cur_name,
                cur_attrs,
                (() => {
                  let _pipe = cur_children;
                  return $list.reverse(_pipe);
                })(),
              ),
              "",
            ];
          } else {
            loop$in = remain;
            loop$current = new StartElement(
              cur_name,
              cur_attrs,
              listPrepend(next, cur_children),
            );
          }
        } else if (next instanceof EndElement) {
          let name = next.name;
          if (name === cur_name) {
            return [
              new StartElement(
                cur_name,
                cur_attrs,
                (() => {
                  let _pipe = cur_children;
                  return $list.reverse(_pipe);
                })(),
              ),
              remain,
            ];
          } else {
            loop$in = remain;
            loop$current = current;
          }
        } else {
          let $1 = do_as_tree(remain, next);
          let child_tree = $1[0];
          let remain_after_child = $1[1];
          loop$in = remain_after_child;
          loop$current = new StartElement(
            cur_name,
            cur_attrs,
            listPrepend(child_tree, cur_children),
          );
        }
      }
    } else if (current instanceof Content) {
      return [current, in$];
    } else {
      return [current, in$];
    }
  }
}

export function as_tree(in$) {
  let $ = get_first_element(in$);
  let first = $[0];
  let remain = $[1];
  let $1 = do_as_tree(remain, first);
  let result = $1[0];
  return result;
}

export function render_html(el) {
  if (el instanceof EmptyElement) {
    return "";
  } else if (el instanceof StartElement) {
    let name = el.name;
    let attrs = el.attributes;
    let children = el.children;
    let _block;
    let _pipe = attrs;
    let _pipe$1 = $list.map(
      _pipe,
      (a) => {
        let k = a.key;
        let v = a.value;
        return (((" " + k) + "=\"") + v) + "\"";
      },
    );
    _block = $list.fold(_pipe$1, "", (acc, s) => { return acc + s; });
    let attrs_str = _block;
    let _block$1;
    let _pipe$2 = children;
    let _pipe$3 = $list.map(_pipe$2, render_html);
    _block$1 = $list.fold(_pipe$3, "", (acc, s) => { return acc + s; });
    let inner_html = _block$1;
    return (((((("<" + name) + attrs_str) + ">") + inner_html) + "</") + name) + ">";
  } else if (el instanceof EndElement) {
    return "";
  } else {
    let txt = el[0];
    return txt;
  }
}

export function extract_attribute(name, root) {
  let _block;
  if (root instanceof StartElement) {
    let attrs = root.attributes;
    _block = attrs;
  } else {
    _block = toList([]);
  }
  let attributes = _block;
  let _pipe = $list.filter_map(
    attributes,
    (a) => {
      let attr_name = a.key;
      if (attr_name === name) {
        let value = a.value;
        return new Ok(value);
      } else {
        return new Error(undefined);
      }
    },
  );
  let _pipe$1 = $list.first(_pipe);
  return $option.from_result(_pipe$1);
}

export function clean_html_string(html_string) {
  let html_as_list = as_list(html_string);
  let $ = get_first_element(html_string);
  let first_element = $[0];
  if (first_element instanceof EmptyElement) {
    return html_string;
  } else {
    let _pipe = $list.map(
      html_as_list,
      (e) => {
        if (e instanceof Content) {
          let a = e[0];
          return a;
        } else {
          return "";
        }
      },
    );
    return $string.join(_pipe, " ");
  }
}
